module.exports = __webpack_public_path__ + "static/media/home.12685621.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/images/home.png
// module id = 1527
// module chunks = 0